import { collection, doc, getCountFromServer, getDoc, getDocs, increment, updateDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { db } from "../FirebaseConfig";
import { useFetchUserData } from "../hooks/user/useFetchUserData";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { formatTimestampForPost } from "../lib/formatTimestampForPost";
import { Card } from "react-bootstrap";
import SideNavUserProfile from "../SideNav/SideNavUserProfile";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import FeedReaction from "../NewsFeed/FeedReaction";
import formatPrice from "../lib/formatPrice";
import UserDisplay from "../UserProfile/UserDisplay";
import UserDisplay2 from "../UserProfile/UserDisplay2";
import FeedReaction3 from "../NewsFeed/FeedReaction3";
import { UserAuth } from "../Context";
import ShowComment2 from "../components/ShowComment2";
import AddComment from "../components/AddComment";
import Slider from "react-slick";
import { getBrandDetails } from "../lib/getBrandDetails";
import useActiveBrandsStore from "../StatesStore/ActiveBrands";
import ColorSelector from "../Experiments/colorDisplay";

function PostedList() {
    const { id } = useParams();
    const [postData, setPostData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [imageLoading, setImageLoading] = useState(true);
    const { userData } = useFetchUserData(postData?.userId || "");
    const [brandData, setBrandData] = useState(null);
    const { user } = UserAuth();
    const [isLiked, setIsLiked] = useState(false);
    const [likesCount, setLikesCount] = useState(0);
    const [commentCount, setCommentCount] = useState(0);
    const [visibleComments, setVisibleComments] = useState(3);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0); // Track current slide index
    const activeBrands = useActiveBrandsStore((state) => state.activeBrands);
    const isSmallScreen = window.innerWidth < 768;

    useEffect(() => {
        const fetchPostAndMedia = async () => {
            try {
                const postRef = doc(db, "posts", id);
                const postSnap = await getDoc(postRef);

                if (postSnap.exists()) {
                    const postData = { ...postSnap.data(), id: postSnap.id };

                    if (postData.type === "image") {
                        const mediaCollectionRef = collection(db, "posts", id, "media");
                        const mediaSnapshot = await getDocs(mediaCollectionRef);

                        const mediaItems = await Promise.all(
                            mediaSnapshot.docs.map(async (document) => {
                                const productId = document.id;
                                const productRef = doc(db, "products", productId);
                                const productSnap = await getDoc(productRef);

                                return {
                                    ...document.data(),
                                    productDetails: productSnap.exists()
                                        ? { ...productSnap.data(), productId: productSnap.id }
                                        : null
                                };
                            })
                        );

                        postData.media = mediaItems;
                    }

                    setPostData(postData);
                    await updateDoc(postRef, {
                        views: increment(1),
                    });
                } else {
                    console.log("No such document!");
                }
            } catch (error) {
                console.error("Error fetching post:", error);
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchPostAndMedia();
    }, [id]);

    useEffect(() => {
        const getCount = async () => {
            try {
                const postRef = doc(db, "posts", postData?.id);
                const commentsCollectionRef = collection(postRef, "comments");
                const snapshot = await getCountFromServer(commentsCollectionRef);
                setCommentCount(snapshot.data()?.count);
            } catch (error) {
                console.error("Error getting comment count:", error);
            }
        };
        getCount();
    }, [postData?.id]);
    const fetchBrandData = async (productData) => {
        try {
            if (!productData?.supplier || !activeBrands) return;

            const result = await getBrandDetails(productData.supplier, activeBrands);
            setBrandData(result);
        } catch (error) {
            console.error("Error getting brand data:", error);
        }
    };
    const currentProductDetails = postData?.media?.[currentSlideIndex]?.productDetails;
    useEffect(() => {
        if (currentProductDetails) {
            fetchBrandData(currentProductDetails);
        }
    }, [currentProductDetails, activeBrands]);
    const handleSlideChange = (index) => {
        setCurrentSlideIndex(index);
    };

    const PrevArrow = ({ style, onClick }) => {
        return (
            <div
                style={{
                    ...style,
                    fontSize: "24px",
                    zIndex: 1,
                    left: "2%",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "2.5rem",
                    cursor: "pointer",
                }}
                onClick={onClick}
            >
                <span
                    className="carousel-control-prev-icon"
                    style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
                ></span>
            </div>
        );
    };

    const NextArrow = ({ style, onClick }) => {
        return (
            <div
                style={{
                    ...style,
                    backgroundColor: "#FFFFFF",
                    fontSize: "24px",
                    zIndex: 1,
                    right: "2%",
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "30px",
                    height: "30px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "2.5rem",
                    cursor: "pointer",
                }}
                onClick={onClick}
            >
                <span
                    className="carousel-control-next-icon"
                    style={{ filter: "brightness(0.1)", width: "10px", height: "10px" }}
                ></span>
            </div>
        );
    };

    const settings = {
        speed: 500,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        swipe: true,
        nextArrow: postData?.media?.length > 0 ? <NextArrow /> : null,
        prevArrow: postData?.media?.length > 0 ? <PrevArrow /> : null,
        afterChange: handleSlideChange, // Add callback for slide change
    };

    if (loading) {
        return <LoadingSpinner />;
    }

    if (!postData) {
        return <div>Post not found!</div>;
    }



    return (
        <div className="p-3" style={{ width: '100%' }}>
            <div className="row g-1">
                {!isSmallScreen && (
                    <div className="col-auto d-flex align-items-start">
                        <button
                            className="btn p-0 "
                            onClick={() => window.history.back()}
                        >
                            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M29.5 34L20.5 25L29.5 16" stroke="#667085" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                )}

                <div className="col-md-11">
                    <div className={`${isSmallScreen ? '' : 'card'} p-0`} style={{ borderRadius: "16px" }}>
                        <div className="row g-0">
                            <div className="col-md-5">
                                {isSmallScreen && (
                                    <button
                                        className="btn p-0"
                                        onClick={() => window.history.back()}
                                        style={{
                                            position: 'absolute',
                                            top: '120px',
                                            left: '12px',
                                            zIndex: 10,
                                            width: '40px',
                                            height: '40px',

                                        }}
                                    >
                                        <svg width="34" height="34" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.5 22L11.5 15L18.5 8" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>

                                    </button>
                                )}
                                <div
                                    style={{
                                        display: "flex",
                                        borderTopLeftRadius: "8px",
                                        borderBottomLeftRadius: "8px",
                                        height: "510px",
                                        position: "relative",
                                        overflow: "hidden",
                                    }}
                                >
                                    {postData?.media?.length > 1 ? (
                                        <Slider {...settings} style={{ width: "100%" }}>
                                            {postData.media.map((item, index) => (
                                                <div key={index}>
                                                    <img
                                                        src={item.url}
                                                        alt={`product-${index}`}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                        </Slider>
                                    ) : (
                                        <img
                                            src={postData?.media?.[0]?.url || "https://via.placeholder.com/500x700"}
                                            alt="main product"
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="col-md-7">
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        height: isSmallScreen ? '515px' : "510px",
                                        width: "100%",
                                        fontFamily: 'Inter',
                                        padding: isSmallScreen ? "12px 0px" : "12px 16px",
                                    }}
                                >
                                    <UserDisplay2 userData={userData} post={postData} />
                                    <hr className="my-2" />
                                   

                                    <div
                                        className=""
                                        style={{
                                            flex: 1,
                                            overflowY: "auto",
                                            padding: "0px 2px",
                                            fontFamily: 'Inter',
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontWeight: 400,
                                                fontSize: '16px',
                                                color: '#676A79',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                lineHeight: '1.5', // Adjust based on your font size
                                                maxHeight: '3em' // 2 lines * 1.5 line-height
                                            }}
                                        >
                                            {postData?.description}
                                        </div>
                                    </div>

                                    <div className="mb-0">
                                        <FeedReaction3 post={postData} commentCount={commentCount} setCommentCount={setCommentCount} />
                                    </div>

                                    <div className="mt-0 w-100">
                                        <div style={{
                                            maxHeight: "240px",
                                            overflowY: "auto",
                                            scrollbarWidth: "none",  /* For Firefox */
                                            msOverflowStyle: "none",  /* For Internet Explorer and Edge */
                                            "&::-webkit-scrollbar": {
                                                display: "none"  /* For Chrome, Safari, and Opera */
                                            }
                                        }}>
                                            {commentCount > 0 && (
                                                <ShowComment2
                                                    post={postData}
                                                    commentCount={commentCount}
                                                    setCommentCount={setCommentCount}
                                                    user={user}
                                                    visibleComments={visibleComments}
                                                    setVisibleComments={setVisibleComments}
                                                />
                                            )}
                                        </div>

                                        {user && (
                                            <div className="mt-1">
                                                <AddComment
                                                    post={postData}
                                                    setCommentCount={setCommentCount}
                                                    user={user}
                                                    type={"comment"}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PostedList;